import { createAction, props } from '@ngrx/store';
import {Item} from '@emm/core/models/item.model';
import {SearchFilter} from '@emm/core/models/search-filter';


export enum ItemsAction {
    Delete = '[Items Management] Delete Item',
    DeleteFailure = '[Management API] Delete Item Failure',
    DeleteSuccess = '[Management API] Delete Item Success',
    LoadAll = '[Items Management] Load All Items',
    LoadAllFailure = '[Management API] Load All Items Failure',
    LoadAllSuccess = '[Management API] Load All Items Success',
    LoadBySize = '[Items Management] Load Items By Size',
    LoadBySizeFailure = '[Management API] Load Items By Size Failure',
    LoadBySizeSuccess = '[Management API] Load Items By Size Success',
    SearchItems = '[Items Management] Search Items',
    Select = '[Items Management] Select Item',
    ToggleEnabled = '[Items Management] Toggle Enabled',
    ToggleEnabledFailure = '[Management API] Toggle Enabled Failure',
    ToggleEnabledSuccess = '[Management API] Toggle Enabled Success'
}

export const ItemsActions = {
    delete: createAction(ItemsAction.Delete, props<{ item: Item }>()),
    deleteFailure: createAction(ItemsAction.DeleteFailure, props<{ error: any }>()),
    deleteSuccess: createAction(ItemsAction.DeleteSuccess),
    loadAll: createAction(ItemsAction.LoadAll),
    loadAllFailure: createAction(ItemsAction.LoadAllFailure, props<{ error: any }>()),
    loadAllSuccess: createAction(ItemsAction.LoadAllSuccess, props<{ items: Item[] }>()),
    loadBySize: createAction(ItemsAction.LoadBySize, props<{ initSize: number }>()),
    loadBySizeFailure: createAction(ItemsAction.LoadBySizeFailure, props<{ error: any }>()),
    loadBySizeSuccess: createAction(ItemsAction.LoadBySizeSuccess, props<{ items: Item[] }>()),
    searchItems: createAction(ItemsAction.SearchItems, props<{ filter: SearchFilter }>()),
    select: createAction(ItemsAction.Select, props<{ tag: string }>()),
    toggleEnabled: createAction(ItemsAction.ToggleEnabled, props<{ item: Item }>()),
    toggleEnabledFailure: createAction(ItemsAction.ToggleEnabledFailure, props<{ error: any }>()),
    toggleEnabledSuccess: createAction(ItemsAction.ToggleEnabledSuccess, props<{ item: Item }>())
};

export const AsyncActions = {
    loadActions: [
        ItemsActions.loadBySize,
        ItemsActions.loadAll,
        ItemsActions.delete,
        ItemsActions.toggleEnabled
    ],
    successActions: [
        ItemsActions.loadBySizeSuccess,
        ItemsActions.loadAllSuccess,
        ItemsActions.deleteSuccess,
        ItemsActions.toggleEnabledSuccess
    ],
    errorActions: [
        ItemsActions.loadBySizeFailure,
        ItemsActions.loadAllFailure,
        ItemsActions.deleteFailure,
        ItemsActions.toggleEnabledFailure
    ]
};
